import { useCallback } from 'react';

import { useAtom } from '@xstate/store/react';

import type { AudioPlayerStreamingAction } from '../effects/AudioPlayerStreamingManager';
import {
	audioPlayerStreamingStore,
	setAudioPlayerStreamingStore,
} from '../state/AudioPlayerStreamingStore';

export const useAudioPlayerStreamingStore = () => {
	const state = useAtom(audioPlayerStreamingStore);

	const updateAudioPlayerStreamingStore = useCallback((action: AudioPlayerStreamingAction): void => {
		setAudioPlayerStreamingStore(action);
	}, []);

	return { state, updateAudioPlayerStreamingStore };
};
